import { notificationCodes } from "./index";
import {
  InfoCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

const BASE_CLASS = "ldNotification ";
const INFO_CLASS = "infoNotification";
const WARNING_CLASS = "warningNotification";
const ERROR_CLASS = "errorNotification";
const SUCCESS_CLASS = "successNotification";

export const getNotificationClassnameFromCode = (code) => {
  let className = INFO_CLASS;
  if (parseInt(code) === notificationCodes.WARNING) className = WARNING_CLASS;
  if (parseInt(code) === notificationCodes.ERROR) className = ERROR_CLASS;
  if (parseInt(code) === notificationCodes.SUCCESS) className = SUCCESS_CLASS;
  return BASE_CLASS + className;
};

export const getNotificationIconFromCode = (code) => {
  let icon = <InfoCircleOutlined />;
  if (parseInt(code) === notificationCodes.WARNING) icon = <ExclamationCircleOutlined />;
  if (parseInt(code) === notificationCodes.ERROR) icon = <CloseCircleOutlined />;
  if (parseInt(code) === notificationCodes.SUCCESS) icon = <CheckCircleOutlined />;
  return icon;
};
